<div id="tableoverview" class="ya-typography" (swiperight)="swiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true" [disableNavigateBack]="true"
    (onNavigateBackClick)="navigateBack()">
    <h1 class="ya-header-title" langkey="phInHouseLocalBasket_Order_Overview"></h1>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="table-info-container">
      <div class=tableNo>
        <h3 langkey="phInHouse_Payment_Table"></h3>
        <h3 class="info-value">{{tableNumberText}}</h3>
      </div>
      <div class="order-count">
        <span langkey="phInHouseService_Ordered_Items"></span>
        <span class="info-value">{{openItemsText}}</span>
      </div>
      <div class="order-amount">
        <span langkey="phInHouseService_Open_Bill"></span>
        <span class="info-value">{{openPriceText}}</span>
      </div>
    </div>
    <ng-container *ngIf="tableSeats$ | async; let tableSeats">
      <ng-container *ngIf="tableSeats.length > 0">
        <ng-container *ngFor="let seat of  tableSeats; let index = index; trackBy: trackTableSeatBy">
          <ng-container *ngIf="isOwner(seat.id) && useEPing">
            <div class="notification-content">
              <div class="notification-header_icon">
                <div class="icon-container">
                  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-handy-notification"></div>
                </div>
              </div>
              <div class="notification_wrapper">
                <ng-container
                  *ngIf="seat.notificationTyp !== ITableSeat_NotificationTyp.NONE; then NotificationTemplate else NoNotificationTemplate">
                </ng-container>
                <ng-template #NotificationTemplate>
                  <ng-container *ngIf="seat.notificationTyp === ITableSeat_NotificationTyp.WebPush">
                    <div class="notification_label">
                      <span langkey="phInHouse_Push_Notification"></span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="seat.notificationTyp === ITableSeat_NotificationTyp.FCM">
                    <div class="notification_label">
                      <span langkey="phInHouse_Push_Notification"></span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="seat.notificationTyp === ITableSeat_NotificationTyp.SMS">
                    <div class="notification_label">
                      <span [innerHTML]="SMSNotificationLabel"></span>
                    </div>
                    <div class="change-number_icon" (click)="ChangePhoneNumber()">
                      <div class="icon-container">
                        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-edit_Fill"></div>
                      </div>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #NoNotificationTemplate>
                  <span langkey="phInHouse_No_Notification">
                  </span>
                </ng-template>
              </div>
            </div>
          </ng-container>
          <div class="user-name">
            <ng-container *ngIf="seat.isGuest && seat.nickname && seat.nickname.length > 0 then user else guest">
            </ng-container>
            <ng-template #user>
              <h3>{{seat.nickname}}</h3>
            </ng-template>
            <ng-template #guest>
              <h3 langkey="phInHouseLocalBasket_Guest_Label"></h3>
            </ng-template>
          </div>
          <div class="divider"></div>
          <!--items-->
          <div [@serviceButtonEntering]="isLoaded" class="ordered_content">
            <div class="ya-item-list-contaner">
              <ng-container *ngFor="let item of sumItems(seat.items); trackBy: trackTableSeatItemBy">
                <ya-basketItemCard [basketItem]="item" [canModifyBasket]="false"></ya-basketItemCard>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <div class="ya-webshop-button-container animate">
      <button mat-flat-button (click)="navigateBack()">
        <span langkey="phGlobal_Return"></span>
      </button>
    </div>
  </div>
</div>